import { useSiteDependencies } from "@modules/site/details/hooks/useSiteDependencies"
import { CmsProvider, CmsVendor } from "@modules/graphql/types"

type CmsVendorsWithDependencies =
  | CmsVendor.Contentful
  | CmsVendor.Cosmicjs
  | CmsVendor.Datocms
  | CmsVendor.Sanity
  | CmsVendor.Shopify

const cmsDependencies = {
  [CmsVendor.Contentful]: `gatsby-source-contentful`,
  [CmsVendor.Cosmicjs]: `gatsby-source-cosmicjs`,
  [CmsVendor.Datocms]: `gatsby-source-datocms`,
  [CmsVendor.Sanity]: `gatsby-source-sanity`,
  [CmsVendor.Shopify]: `gatsby-source-shopify`,
}

export function useIntegrationSuggestions(
  siteId: string,
  cmsIntegrations: CmsProvider[]
) {
  const { siteDependencies, loading } = useSiteDependencies(siteId)

  const installedDependenciesNames = siteDependencies.map(({ name }) => name)
  const availableIntegrations = cmsIntegrations || []
  const suggestedIntegrations: CmsProvider[] = []
  const otherIntegrations: CmsProvider[] = []

  availableIntegrations.forEach(cmsIntegration => {
    const cmsDependency =
      cmsDependencies[cmsIntegration.name as CmsVendorsWithDependencies]
    const shouldSuggest =
      cmsDependency && installedDependenciesNames.includes(cmsDependency)

    if (shouldSuggest) {
      suggestedIntegrations.push(cmsIntegration)
    } else {
      otherIntegrations.push(cmsIntegration)
    }
  })

  return [
    {
      suggestedIntegrations,
      otherIntegrations,
    },
    { loading },
  ]
}
